// extracted by mini-css-extract-plugin
export default {"container":"ProjectDropdown_container__pOl1E","link":"ProjectDropdown_link__3S3hv","selected":"ProjectDropdown_selected__NrLXT"};